module.exports = __webpack_public_path__ + "img/portMappingBack.6a7e9870.jpg";